import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
  name: 'getFormControl',
  standalone: true,
  pure: true,
})
export class GetFormControlPipe implements PipeTransform {
  // TODO: set return type
  transform(form?: FormGroup, fieldName?: string): any {
    if (fieldName) {
      return form?.get(fieldName);
    }
    return form;
  }
}
